export default __webpack_public_path__ + "static/ronaldo-d88b155896d039e5eefd6aa72c4298d2.jpeg";